import { Slide, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useRef, useState } from "react";
import { MessageText, PromotionsContainer } from "../styles/promotiom";
import { Colors } from "../styles/promotiom";

const messages = [
  "כרגע המשלוחים הם בירושלים והסביבה בלבד- בקרוב בכל חלקי הארץ!",
  "שיינ'ס סטוק - עולם של יצירה",
  " שיינ'ס סטוק - הקניה הזולה ביותר",

];

export default function Promotions() {
  const containerRef = useRef();
  const [show, setShow] = useState(true);
  const [messageIndex, setMessageIndex] = useState(0);

 useEffect(() => {
  setShow(true);

  const visibleTime = messageIndex === 0 ? 5000 : 3000;

  const hideTimer = setTimeout(() => {
    setShow(false);
  }, visibleTime);

  const nextTimer = setTimeout(() => {
    setMessageIndex((prev) => (prev + 1) % messages.length);
  }, visibleTime + 1000); // שניה למעבר

  return () => {
    clearTimeout(hideTimer);
    clearTimeout(nextTimer);
  };
}, [messageIndex]);

  return (
    <PromotionsContainer 
    ref={containerRef}
    sx={{ borderRadius: 2 ,
      overflow: 'hidden',
      width: '100%',
      maxWidth: '1300px',
      mx: 'auto',
      my: 2,
    minHeight:10,
    }}
    >
      {/* רקע אפור + קצוות מעוגלים */}
      <Box
        sx={{
          bgcolor: "#f2f5f7",   // אפור עדין
          // borderRadius: 4,      // קצוות עגולים
          px: 2,
          py: 0.75,
        }}
      >
        <Slide
          direction={show ? "left" : "right"}
          in={show}
          container={containerRef.current}
          timeout={{ enter: 500, exit: 200 }}
        >
          <Box display="flex" justifyContent="center" alignItems="center">
            {/* כיתוב ורוד */}
            <MessageText sx={{ color: "#D81B60", fontWeight: 500 }}>
              {messages[messageIndex]}
            </MessageText>
          </Box>
        </Slide>
      </Box>
    </PromotionsContainer>
  );
}
